<template>
    <div class="profile-stats">
        <div class="profile-wrap">
        <div class="stats-item">
            <p class="stats-item__title">Событий</p>
            <p class="stats-item__text">{{ statistic.created }}</p>
        </div>
        <div class="stats-item">
            <p class="stats-item__title">Вступлений</p>
            <p class="stats-item__text">{{ statistic.joined }}</p>
        </div>
        <div class="stats-item">
            <p class="stats-item__title">Постов</p>
            <p class="stats-item__text">{{ statistic.posts }}</p>
        </div>
        <div class="stats-item">
            <p class="stats-item__title">Мест</p>
            <p class="stats-item__text">{{ statistic.places }}</p>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'UserStatistic',
    props: {
        statistic: {
            type: Object,
            require: true
        } 
    }
}
</script>